import { render, staticRenderFns } from "./AddInspectionItem.vue?vue&type=template&id=0dba8360"
import script from "./AddInspectionItem.vue?vue&type=script&lang=js"
export * from "./AddInspectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports